<template>    
    <searchform-content inline-template :key="version">
        <div class="suchformularContentContainer" :class="[overlayIsActive ? 'menu-sticky visible' : '']">
            <!-- <div class="container" v-if="dictionary"> -->
            <div class="container">
                <div class="row ganzeZeileMitAbstand">
                    <div class="col-12">
                        <content-search-field></content-search-field>
                    </div>
                </div>
                <content-search-results></content-search-results>
                <!-- @Html.Partial("VueComponents/Products/PflichttextModal") -->
            </div>
        </div>
    </searchform-content>   
</template>

<script lang="ts" setup>
    import { onBeforeMount } from 'vue';
    import ContentSearchField from './content-search-field.vue';
    import contentSearchResults from './content-search-results.vue';
    import { emitterInstance } from '@/classes/emitter';

    let overlayIsActive = false;
    const emitter = emitterInstance;
    let version = 0;

    onBeforeMount(()=>{
        emitter.on("showSearchOverlay", (state):void =>{
                overlayIsActive = state as boolean;
                version++;
            })            
    })
</script>